
import ReactDOM from 'react-dom/client';
// import "./index.css"
import App from './App';
// import "./index.css"



const root = ReactDOM.createRoot(document.querySelector('#root'));
root.render(

      

      <App />

  

);


